import React, { Component } from 'react';
import { withRouter } from 'react-router';
import './imgs.scss';
import { Modal, message, Result, Button } from 'antd';
import { Link } from 'react-router-dom';

import { getImgList } from '../../assets/api/upload';
import { copyText } from '../../assets/scripts/utils';
import { userAuth } from '../../assets/api/user';

class Imgs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      // pageIndex: 1,
      // pageSize: 10,
      // total: 0,
      list: [],

      isModalVisible: false,
      currentPath: '',
      isAuth: false,
    };
  }

  componentDidMount() {
    this.getAuth();
  }

  getAuth = () => {
    userAuth().then((res) => {
      if (res.data.auth.indexOf('sle') > -1) {
        this.setState({ isAuth: true });
        this.GetList();
      } else {
        this.setState({ isAuth: false });
      }
    });
  };

  // 列表
  GetList = (p) => {
    this.setState({ ...p, loading: true });
    const { pageIndex, pageSize } = this.state;
    getImgList({ pageIndex, pageSize }).then((res) => {
      this.setState({
        list: res.list,
        // total: res.total - 0,
        loading: false,
      });
    });
  };

  handleCancel = () => {
    this.setState({
      currentPath: '',
      isModalVisible: false,
    });
  };

  openModal(url) {
    // console.log(13, url);
    this.setState({
      isModalVisible: true,
      currentPath: url,
    });
  }

  async copyPath(url) {
    await copyText(url).then(() => {
      message.success('复制成功');
    });
  }

  render() {
    const { list, isAuth, isModalVisible, currentPath } = this.state;

    return (
      <div>
        {!isAuth && (
          <Result
            status="warning"
            title="暂无权限访问"
            extra={
              <Button type="primary" key="console">
                <Link to={'/'}>返回首页</Link>
              </Button>
            }
          />
        )}
        <div className="card-list">
          {isAuth &&
            list.length > 0 &&
            list.map((item) => (
              <div className="card" key={item}>
                <img className="img pos" src={item} alt="" />
                <div className="mask pos">
                  <span onClick={() => this.openModal(item)}>放大</span>
                  <span onClick={() => this.copyPath(item)}>复制</span>
                </div>
              </div>
            ))}
          <Modal
            title="图片预览"
            visible={isModalVisible}
            onCancel={this.handleCancel}
            width={850}
            footer={null}
          >
            <img width="800" src={currentPath} alt="" />
          </Modal>
        </div>
      </div>
    );
  }
}

export default withRouter(Imgs);
